import { Component, inject, Input } from '@angular/core';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { UpperCasePipe } from '@angular/common';

interface TitleI {
  name : string
  path ?: string
  back ?: boolean,
}

@Component({
  selector: 'app-title-component',
  imports: [MatToolbarModule, MatIconModule, MatButtonModule, MatTooltipModule],
  templateUrl: './title-component.html',
  styleUrl: './title-component.css',
})

export class TitleComponent {

    @Input() data !: TitleI

    router = inject(Router)

    path : string = ''

    constructor(

    ){
      const navigation = this.router.getCurrentNavigation()
      const prev = navigation?.previousNavigation
      if(prev)
        this.path= prev.finalUrl?.toString() || ''
      else
        this.path=''
    }

    ngOnInit(): void {

    }
    back(){
      this.router.navigateByUrl('/'+(this.data.path??this.path))
    }
}
